import { type QueryOptions } from '@tanstack/query-core'

import { type PartnerEntity } from '@/libs/api'

import { fetchPartners } from '../api'
import { partnersQueryKeys } from '../query-keys'

/**
 * Select用のパートナー一覧のQueryOptionsを返す
 */
export const getPartnersSelectQueryOptions = (
  tenantKey: string,
  dcId?: number
): Required<Pick<QueryOptions<PartnerEntity[]>, 'queryKey' | 'queryFn'>> => {
  return {
    queryKey: partnersQueryKeys.select(tenantKey, dcId),
    queryFn: async ({ signal }) => {
      const { data } = await fetchPartners(
        {
          tenantKey,
          dcId
        },
        signal
      )
      return data
    }
  }
}
